import store from '@/store'

class AccountAPI {
  constructor(baseURL) {
    this.baseURL = baseURL
  }

  async insecure_get(url) {
    let params = this.get_headers('GET')

    return await fetch(this.baseURL + url, params)
  }

  async insecure_post(url, data) {
    const params = this.get_headers('POST')
    params.body = JSON.stringify(data) 
    
    return fetch(this.baseURL + url, params)
  }

  async put(url, data) {
    return this.process(url, 'PUT', data)
  }
  
  async post(url, data) {
    return this.process(url, 'POST', data)
  }

  async get(url) {
    return this.process(url, 'GET')
  }

  async delete(url) {
    return this.process(url, 'DELETE')
  }

  get_headers(method) {
    const params = {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: method,
    }

    return params
  }

  async process(url, method, data=null) {
    let params = this.get_headers(method)
    if (data) {
      params.body = JSON.stringify(data)
    }
  
    let response = await fetch(this.baseURL + url, params)

    if (response.status != 401) {
      return response
    }
    
    store.commit('auth/LOGOUT')
    return { ok: false }
  }
}

let host = location.hostname.split('.')
host[1] = process.env.VUE_APP_API_SUBDOMAIN
let api_host = `${ location.protocol }//${ host.join('.') }`

if (process.env.VUE_APP_API_PORT) {
  api_host += ':' + process.env.VUE_APP_API_PORT
}

export default new AccountAPI(api_host + '/store_api')